<template>
  <CommonLayout footer="floristFooter">
    <FloristHeader @suggestion="suggestion" />
    <MeetingLayout :type="consts.meetingType.floristStyleImageProposal">
      <div class="base-color mh-550 shadow">
        <BOverlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="col-sm-12 row">
              <div class="col-sm-6 p-3 mt-2">
                <span>お好みの画像を選択してください。</span>
              </div>
            </div>
            <div class="col-sm-12 overflow-auto">
              <div
                class="card-columns p-3 w-100 image-column-count"
                v-for="(styleImages, index) in suggetionStyleData()"
                :key="index"
              >
                <div
                  class="card position-relative border-0 bg-unset card-sqr-gray"
                  v-for="styleImage in styleImages"
                  :key="styleImage.imageId"
                >
                  <div
                    class="p-0"
                    :id="'select-image-' + styleImage.imageId"
                    @click="selectImage(styleImage)"
                  >
                    <div>
                      <img
                        :src="styleImage.imagePath"
                        class="w-100 ar-3-2"
                        :alt="styleImage.styleNumber"
                      />
                      <h5 class="position-absolute m-0 image-overlay-text">
                        {{ styleImage.styleNumber }}
                      </h5>
                      <img
                        src="@/assets/img/heart-active.png"
                        class="position-absolute like-icon"
                        style="right: 10px; top: 10px;"
                        v-show="selectedImageIds.includes(styleImage.imageId)"
                      />
                      <img
                        src="@/assets/img/heart-passive.png"
                        class="position-absolute like-icon"
                        style="right: 10px; top: 10px;"
                        v-show="!selectedImageIds.includes(styleImage.imageId)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BOverlay>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import FloristHeader from '@/components/FloristHeader.vue'
import SelectedStyleImage from '@/components/SelectedStyleImage'
import SuggestionStyleModel from '@/models/SuggestionStyleModel'
import SignalingModel from '@/models/SignalingModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'
import { createApp } from 'vue'

export default {
  name: 'FloristMeetingStyleImageProposal',
  components: {
    CommonModal,
    CommonLayout,
    MeetingLayout,
    FloristHeader,
    SelectedStyleImage
  },
  data () {
    return {
      overlayShow: false,
      imageRowMaxNum: 3,
      // 旧:selectedImages(IDsのみ) + DOM操作 → 新:selectedItemsで描画
      selectedItems: [],
      isSendFirstSignalingData: false,
      loginStatus: ''
    }
  },
  computed: {
    selectedImageIds () {
      return this.selectedItems.map(x => x.imageRef)
    },
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true

        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          SignalingModel.sendAgainEvent('fromFlorist')
        }
      }
    },
    getSignalingData (newData, oldData) {
      if (newData?.event === 'again') {
        this.sendSignalingApiData()

        const selectedList = this.buildSelectedList()
        SignalingModel.sendClickEvent('select-image-0', this, { selected: selectedList })
        return
      }

      if (newData?.current_path && oldData) {
        const synchPass = newData.current_path.replace('customer', 'florist')
        if (synchPass !== this.$route.path) {
          this.$router.push(synchPass)
        }
      }

      if (newData?.event === 'click' && newData.selected) {
        // ★ Vue3対応：DOM削除→配列を作り直す
        this.selectedItems = Object.keys(newData.selected).map((id) => ({
          imageRef: String(id),
          url: newData.selected[id].url,
          styleNumber: newData.selected[id].styleNumber
        }))

        let separator = 'select-image-'
        const index = newData.id.indexOf(separator)
        let removeFlag = true
        if (index !== -1) {
          let id = newData.id.substring(index + separator.length)
          for (const newId in newData.selected) {
            if (newId === id) {
              removeFlag = false
              break
            }
          }
          if (removeFlag) {
            let selectedImage = document.getElementById('selected-image-' + id)
            // 選択画像欄から削除
            selectedImage.remove()
            return
          }
          const app = createApp(SelectedStyleImage, {
            url: newData.selected[id].url,
            imageRef: String(id),
            styleNumber: newData.selected[id].styleNumber,
            isShowStyleNumber: true
          })
          const instance = app.mount(document.createElement('div'))
          let selectedStyleImagesId = 'selected-style-images'
          const selectedStyleImages = document.getElementById(selectedStyleImagesId)
  
          // 選択画像欄に追加
          selectedStyleImages.appendChild(instance.$el)
        }
      }
    }
  },
  methods: {
    suggetionStyleData () {
      const store = SuggestionStyleModel.getStore()
      if (!store) return []
      const length = Math.ceil(store.images.length / this.imageRowMaxNum)
      return new Array(length).fill().map((_, i) =>
        store.images.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
    },
    async setApiData (isReload = false) {
      this.overlayShow = true

      if (localStorage.getItem('suggestionData') === null) {
        this.overlayShow = false
        return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
      }

      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.includes(currentProjectType)) {
        this.overlayShow = false
        return this.$router.push('/florist/meeting/estimate')
      } else if (!this.consts.projectType.main.includes(currentProjectType)) {
        this.overlayShow = false
        return this.nextPage()
      }

      const params = JSON.parse(localStorage.getItem('suggestionData'))
      try {
        await SuggestionStyleModel.apiSetStore(this.$refs.commonModal, params, () => {
          this.selectedItems = []
          this.overlayShow = false
        })
      } catch (e) {
        this.overlayShow = false
        return false
      }

      if (((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) &&
          this.loginStatus?.prodInst !== '1') {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    sendSignalingApiData () {
      if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
        SignalingModel.sendClickEvent('reload', this)
      }

      const store = SuggestionStyleModel.getStore()
      if (!store) return

      for (const img of store.images) {
        SignalingModel.sendApiEvent('getSuggestionStyles', this, {
          status: store.status,
          message: store.message,
          images: img
        })
      }
    },
    nextPage () {
      const targetPath = '/florist/meeting/product_proposal'
      SignalingModel.sendClickEvent('next', this, { target_path: targetPath.replace('florist', 'customer') })
      this.$router.push(targetPath)
    },
    reload () {
      SignalingModel.sendClickEvent('reload', this)
      this.setApiData(true)
    },
    selectImage (styleImage) {
      if (!fstore.getters.isOperationPossible) return

      const imageId = String(styleImage.imageId)
      const exists = this.selectedImageIds.includes(imageId)

      if (exists) {
        this.selectedItems = this.selectedItems.filter(x => x.imageRef !== imageId)
        let selectedImage = document.getElementById('selected-image-' + imageId)
        // 選択画像欄から削除
        selectedImage.remove()
        this.sendSignalingSelectedImageData(imageId)
        return
      }

      if (this.selectedItems.length >= this.config.styleImageMaxSelect) return

      const add = {
        [imageId]: {
          url: styleImage.imagePath,
          styleNumber: styleImage.styleNumber
        }
      }
      this.sendSignalingSelectedImageData(imageId, add)

      this.selectedItems.push({
        imageRef: imageId,
        url: styleImage.imagePath,
        styleNumber: styleImage.styleNumber
      })

      const app = createApp(SelectedStyleImage, {
        url: styleImage.imagePath,
        imageRef: imageId,
        styleNumber: styleImage.styleNumber,
        isShowStyleNumber: true
      })
      const instance = app.mount(document.createElement('div'))
      let selectedStyleImagesId = 'selected-style-images'
      const selectedStyleImages = document.getElementById(selectedStyleImagesId)

      // 選択画像欄に追加
      selectedStyleImages.appendChild(instance.$el)
    },
    buildSelectedList () {
      const selectedList = {}
      for (const item of this.selectedItems) {
        selectedList[item.imageRef] = {
          url: item.url,
          styleNumber: item.styleNumber
        }
      }
      return selectedList
    },
    sendSignalingSelectedImageData (data, addURLs) {
      const selectedList = this.buildSelectedList()
      if (addURLs) {
        Object.assign(selectedList, addURLs)
      }
      SignalingModel.sendClickEvent('select-image-' + data, this, {'selected': selectedList})
    },
    suggestion () {
      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.includes(currentProjectType)) {
        this.$router.push('/florist/meeting/estimate')
      } else if (!this.consts.projectType.main.includes(currentProjectType)) {
        this.nextPage()
      } else {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      }
    }
  },
  mounted () {
    this.setApiData()
    this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
  },
  unmounted () {
    if (SuggestionStyleModel.getStore()) {
      SuggestionStyleModel.removeStore()
    }
  }
}
</script>
